"use client";

import { c as _c } from "react/compiler-runtime";
import type { AthenaCoverageConfirmationMetadata } from "@/src/models/task-approval";
function expectedLabel(coverage: AthenaCoverageConfirmationMetadata["expectedCoverages"][number]): string {
  return coverage.casePolicy ? "Case policy" : coverage.order === 1 ? "Primary" : "Secondary";
}
function currentLabel(coverage: AthenaCoverageConfirmationMetadata["currentCoverages"][number]): string {
  return coverage.casePolicy ? "Case policy" : coverage.sequence === 1 ? "Primary" : coverage.sequence === 2 ? "Secondary" : "Unsequenced";
}
export function AthenaCoverageEvidence(t0) {
  const $ = _c(16);
  const {
    metadata
  } = t0;
  let t1;
  if ($[0] !== metadata.reviewReasons) {
    t1 = metadata.reviewReasons.length ? <div><p className="font-medium">Issues</p><ul className="list-disc space-y-1 pl-5 text-muted-foreground">{metadata.reviewReasons.map(_temp)}</ul></div> : null;
    $[0] = metadata.reviewReasons;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <p className="font-medium">Expected</p>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== metadata.expectedCoverages) {
    t3 = metadata.expectedCoverages.map(_temp2);
    $[3] = metadata.expectedCoverages;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t3) {
    t4 = <div>{t2}<ul className="list-disc pl-5">{t3}</ul></div>;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <p className="font-medium">Currently in Athena</p>;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== metadata.currentCoverages) {
    t6 = metadata.currentCoverages.length === 0 ? <li>No coverage found</li> : metadata.currentCoverages.map(_temp3);
    $[8] = metadata.currentCoverages;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== t6) {
    t7 = <div>{t5}<ul className="list-disc pl-5">{t6}</ul></div>;
    $[10] = t6;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== t1 || $[13] !== t4 || $[14] !== t7) {
    t8 = <>{t1}{t4}{t7}</>;
    $[12] = t1;
    $[13] = t4;
    $[14] = t7;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  return t8;
}
function _temp3(coverage_0) {
  return <li key={coverage_0.insuranceId}>{currentLabel(coverage_0)}: {coverage_0.planName ?? "Unknown plan"} (package{" "}{coverage_0.insurancePackageId ?? "missing"}){coverage_0.subscriberId ? ` · Subscriber ${coverage_0.subscriberId}` : ""}</li>;
}
function _temp2(coverage) {
  return <li key={coverage.order}>{expectedLabel(coverage)}: {coverage.label}</li>;
}
function _temp(reason) {
  return <li key={reason}>{reason}</li>;
}